/**
 * Full Speisekarte dietary chrome — per arrangement (not highlight story rules).
 *
 * - `labeled`: icon + short label chips under the dish (Category Gallery, Editorial, PDF)
 * - `iconsInline`: icon-only after the dish name (Classical columns / Grid, Category Chips,
 *   Flow, Street Board, Dish Cards)
 */
import { REGISTRY_BLOCK } from '@web-studio/shared-schemas';

const P = REGISTRY_BLOCK.presentation;

export type FullMenuDietaryMode = 'labeled' | 'iconsInline' | 'none';

const LABELED = new Set<string>([
  P.staticMenuCategoryGallery,
  P.staticMenuPdfCard,
  P.staticMenuEditorialBoard,
]);

const ICONS_INLINE = new Set<string>([
  P.staticMenuGrid,
  P.staticMenuCategoryChips,
  P.dynamicMenuFlow,
  P.staticMenuStreetBoard,
  P.staticMenuDishCards,
]);

/**
 * Chip rail scrolls in one row (phone always; wider sites when count exceeds this).
 * Below the threshold, wider sites wrap + center.
 */
export const MENU_FLOW_CHIP_SCROLL_THRESHOLD = 8;

export function resolveFullMenuDietaryMode(
  registryBlockKey: string | null | undefined,
  componentType?: string | null,
): FullMenuDietaryMode {
  if (registryBlockKey && LABELED.has(registryBlockKey)) {
    return 'labeled';
  }
  if (registryBlockKey && ICONS_INLINE.has(registryBlockKey)) {
    return 'iconsInline';
  }
  if (componentType === 'Dynamic_Menu_Flow' || componentType === 'MenuGrid_3Column') {
    return 'iconsInline';
  }
  if (componentType === 'Drinks_List_Static') {
    return 'labeled';
  }
  return 'labeled';
}
